<template>
  <v-card
    @drop.prevent="onDrop($event)"
    @dragover.prevent="dragover = true"
    @dragenter.prevent="dragover = true"
    @dragleave.prevent="dragover = false"
    :class="{ 'grey lighten-2': dragover }"
    hover>
    <input @change="onFileChange" type="file" ref="file" multiple style="display: none" />
    <!-- Height comes from the padded content (no fixed card height), so the label never gets squeezed;
         both states are 72px tall, so picking a file doesn't resize the dialog -->
    <v-card-text @click="$refs.file.click()" class="py-3 px-0" style="overflow: hidden">
      <div v-if="uploadedFiles.length === 0" class="d-flex flex-column align-center justify-center text-center px-4">
        <v-icon class="mb-1">mdi-cloud-upload</v-icon>
        <span class="text-body-2">{{ text }}</span>
      </div>
      <!-- One 48px row per file; the action's default margins would make it taller -->
      <v-list-item v-for="item in uploadedFiles" :key="item.name">
        <v-list-item-content class="px-0 py-0">
          <v-list-item-title>
            {{ item.name }}
            <span class="ml-1 text--secondary"> {{ item.size }} bytes</span>
          </v-list-item-title>
        </v-list-item-content>

        <v-list-item-action class="my-0">
          <v-btn @click.stop="removeFile(item.name)" icon>
            <v-icon> mdi-close-circle</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "FileUploader",
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    initialFiles: {
      required: false,
      type: Array,
      default() {
        return [];
      },
    },
    text: {
      type: String,
      required: false,
      default() {
        return "Drop your file(s) here, or click to select them.";
      },
    },
  },
  data() {
    return {
      dragover: false,
      uploadedFiles: [],
    };
  },
  methods: {
    closeDialog() {
      // Remove all the uploaded files
      this.uploadedFiles = [];
    },
    removeFile(fileName) {
      // Find the index of the
      const index = this.uploadedFiles.findIndex((file) => file.name === fileName);
      // If file is in uploaded files remove it
      if (index > -1) this.uploadedFiles.splice(index, 1);

      if (this.$refs.file) {
        this.$refs.file.value = null;
      }
    },
    onDrop(e) {
      this.dragover = false;
      // A FileList has no forEach
      const files = Array.from(e.dataTransfer.files);

      // Nothing to add (e.g. dropped text); keep the files already picked
      if (files.length === 0) {
        return;
      }

      // If user has uploaded multiple files but the component is not multiple throw error; the picked files stay
      if (!this.multiple && files.length > 1) {
        this.$store.dispatch("error", "Only one file can be uploaded at a time...");
      }

      // The dropped files replace the ones already picked
      else {
        this.uploadedFiles = files;
      }
    },
    onFileChange(event) {
      this.dragover = false;
      const files = event.target.files;

      if (files.length === 0) {
        return;
      }

      // If user has uploaded multiple files but the component is not multiple throw error
      if (!this.multiple) {
        if (files.length > 1) {
          this.$store.dispatch("error", "Only one file can be uploaded at a time...");
        }

        // if not multiple enabled, only use one file
        this.uploadedFiles = [files[0]];
      }
      // Add each file to the array of uploaded files (a FileList has no forEach)
      else {
        Array.from(files).forEach((element) => this.uploadedFiles.push(element));
      }
    },
    submit() {
      // If there aren't any files to be uploaded throw error
      if (!this.uploadedFiles.length > 0) {
        this.$store.dispatch("error", "There are no files to upload");
      } else {
        // Send uploaded files to parent component
        this.$emit("filesUploaded", this.uploadedFiles);
        // Close the dialog box
        this.closeDialog();
      }
    },
  },
  created() {
    this.uploadedFiles = this.initialFiles;
  },
};
</script>
